<template>
  <div>
    SURVEY : {{ $page.props.survey.title }}

    <h2>Questions</h2>

    <survey-question v-for="(question, key) in $page.props.survey.questions" :key="key" :question="question"
                     v-model="form.responses[key]"></survey-question>

    <input type="text" placeholder="email" v-model="form.email"/>

    <button @click.prevent="submitForm">Valider</button>

  </div>
</template>

<script>
import SurveyQuestion from "@/Components/SurveyQuestion";

export default {
  name: "Show",
  components: {
    SurveyQuestion
  },
  data() {
    return {
      form: {
        surveyId: this.$page.props.survey.id,
        email: '',
        responses: []
      }
    }
  },
  methods: {
    submitForm() {
      this.$inertia.post(route('survey.store', this.form.surveyId), this.form);
    }
  }
}
</script>

<style scoped>

</style>
